export var Events = [
  'keydown',
  'keypress',
  'keyup',
  'dragenter',
  'dragleave',
  'dragover',
  'mousedown',
  'mouseup',
  'mousemove',
  'mouseout',
  'mouseover',
  'click',
  'dblclick',
  'wheel',
  'mousewheel',
  'touchstart',
  'touchmove',
  'touchend'
];

export var TooltipShowEvent = 'mousemove';

export var TooltipHideEvent = 'mouseout';

export var HrefEvent = 'click';



// WEBPACK FOOTER //
// ./~/vega-scenegraph/src/util/events.js